module.exports = __webpack_public_path__ + "static/media/rounded-rect-primary.d0eaea44.png";